import { render, staticRenderFns } from "./SelectClientInvoices.vue?vue&type=template&id=bbdbec8c"
import script from "./SelectClientInvoices.vue?vue&type=script&lang=js"
export * from "./SelectClientInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports